import { Box } from '@mui/material';

import { useFormikContext } from 'formik';
import { RaptorJobFormValues } from '../../../RaptorJobValidationSchema';
import CustomerModal from '@/customers/presentation/pages/CustomersPage/CustomersManagementTab/CustomerModal';
import { JobSiteCreateModal } from '@/jobs/presentation/pages/JobsPage/JobDrawer/JobSiteCreateModal';
import { useState } from 'react';
import { CustomerInfoSection } from './sections/CustomerInfoSection';
import { JobDetailsSection } from './sections/JobDetailsSection';
import { RecurrenceSection } from './sections/RecurrenceSection';
import { NotesSection } from './sections/NotesSection';
import { EstimatesSection } from './sections/EstimatesSection';
import { SalesSection } from './sections/SalesSection';

interface RaptorJobInfoStepProps {
  jobSiteSearchTerm: string;
  setJobSiteSearchTerm: (term: string) => void;
  setSelectedCustomerName?: (term: string) => void;
  disableJobSiteSelection?: boolean; // When true, jobSiteId field is disabled (e.g., when creating from Job Sites page)
}

export const RaptorJobInfoStep = ({ jobSiteSearchTerm, setJobSiteSearchTerm, setSelectedCustomerName }: RaptorJobInfoStepProps) => {
  const { values, setFieldValue, setFieldTouched, setFieldError } = useFormikContext<RaptorJobFormValues>();

  const [isCreateCustomerModalOpen, setIsCreateCustomerModalOpen] = useState(false);
  const [isCreateJobSiteModalOpen, setIsCreateJobSiteModalOpen] = useState(false);

  const handleCreateCustomerSuccess = (customer: { id: number; companyName: string }) => {
    setFieldError('customerId', undefined);
    setFieldTouched('customerId', false, false);
    setFieldValue('customerId', customer.id, false);
    setFieldValue('customerName', customer.companyName, false);
    setSelectedCustomerName?.(customer.companyName);
    setIsCreateCustomerModalOpen(false);
  };

  return (
    <Box>
      <CustomerInfoSection
        onAddNewCustomer={() => setIsCreateCustomerModalOpen(true)}
        onCustomerChanged={() => {
          setFieldValue('jobSiteId', null);
          setJobSiteSearchTerm('');
          setFieldValue('callerId', null);
        }}
        setSelectedCustomerName={setSelectedCustomerName}
      />
      <JobDetailsSection
        jobSiteSearchTerm={jobSiteSearchTerm}
        onJobSiteSearchTermChange={setJobSiteSearchTerm}
        onOpenCreateJobSiteModal={() => setIsCreateJobSiteModalOpen(true)}
      />
      <SalesSection />
      <RecurrenceSection />
      <NotesSection />
      <EstimatesSection />
      <CustomerModal
        open={isCreateCustomerModalOpen}
        onClose={() => setIsCreateCustomerModalOpen(false)}
        onSuccess={handleCreateCustomerSuccess}
      />
      <JobSiteCreateModal
        customerId={values.customerId ?? 0}
        customerName={values.customerName ?? ''}
        isOpen={isCreateJobSiteModalOpen && !!values.customerId}
        toggleModal={() => setIsCreateJobSiteModalOpen((state) => !state)}
        setJobSiteFieldValue={(jobSiteId) => setFieldValue('jobSiteId', jobSiteId)}
      />
    </Box>
  );
};
